export const Exclamation = props => {
  return (
    <span {...props}>
      <svg
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        stroke={props.color ? props.color : 'black'}
        fill={props.color ? props.color : 'black'}
      >
        <path d="M11 15h2v2h-2zm0-8h2v6h-2z" />
      </svg>
    </span>
  );
};
